<template>
  <div>
    <el-form :model="searchItem" inline size="small">
      <el-form-item label="ID">
        <el-input v-model.trim="searchItem.id" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="应用名称">
        <el-select v-model="searchItem.app_store_id" filterable clearable>
          <el-option v-for="item in appList" :key="item.id" :value="item.id" :label="`${item.name}(${item.code})`"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用数量">
        <el-input v-model.trim="searchItem.app_quantity" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="代金券编码">
        <el-input v-model.trim="searchItem.voucher_code" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="安装设备SN">
        <el-input v-model.trim="searchItem.sn" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="reset" plain>重置</el-button>
      </el-form-item>
    </el-form>
    <vue-table :table-data="tableData" :count-list="countList">
      <template slot="app_store_id" slot-scope="{row}">
        <span>{{formatId(row.app_store_id, appList)}}</span>
      </template>
    </vue-table>
    <vue-pagination :paging-data="pagingData" @getData="getData" ref="paging"/>
  </div>
</template>

<script>
import {PagingData} from "@mixins"
export default {
  name: "index",
  mixins: [PagingData],
  data() {
    return {
      searchItem: {
        id: "",
        app_store_id: "",
        app_quantity: "",
        voucher_code: "",
        sn: "",
      },
      commitItem: null,
      countList: [
        {name: "总记录", count: 0},
      ],
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "ID", property: "id"},
          {label: "应用名称", property: "app_store_id"},
          {label: "应用数量", property: "app_quantity"},
          {label: "代金券编码", property: "voucher_code", width: 300},
          {label: "安装时间", property: "create_at"},
          {label: "安装设备SN", property: "sn"},
          {label: "到期时间", property: "expire_at"},
        ],
      },
      appList: []
    }
  },
  methods: {
    formatId(id, list) {
      return list.find(item => item.id === id)?.name || "-"
    },
    search() {
      this.commitItem = {...this.searchItem};
      this.pagingData.currentPage = 1;
      this.getData();
    },
    reset() {
      Object.keys(this.searchItem).forEach(key => this.searchItem[key] = "");
      this.search();
    },
    async getData() {
      let nv = {
        page: this.pagingData.currentPage,
        limit: this.pagingData.pageSize,
      };
      this.copyObjValue(nv, this.commitItem);
      const res = await this.$Http.getDeviceAppList(nv);
      if (res?.data) {
        let total = +res.data.total || 0;
        this.pagingData.total = total;
        this.countList[0].count = total;
        this.tableData.tableList = res.data.list || [];
      }
    },
    async getApp() {
      const res = await this.$Http.getAppOption();
      if (res?.data) {
        this.appList = res.data || [];
      }
    },
  },
  mounted() {
    this.getApp();
    this.getData();
  }
}
</script>

<style scoped lang="scss">

</style>

